import { createStore } from 'vuex';
import jsonSerializer from '@/composables/jsonSerializer';
import { microbesStoreVersion, microbesStore } from '@/composables/microbesData';
import { microbesInfo } from '@/composables/microbesData';
import { stagesInfo } from '@/composables/stagesInfo';

export default createStore({
  state: {
    microbesStore: null,
  },
  getters: {
    correctMicrobes(state) {
      const correctMicrobes = Object.entries(state.microbesStore).filter(item => {
        const [ key, _ ] = item;
        return microbesInfo[key].is_correct;
      });
      return Object.keys(Object.fromEntries(correctMicrobes));
    },
    titleAcquiredMicrobes(state) {
      const correctMicrobes = Object.entries(state.microbesStore).filter(item => {
        const [ key, value ] = item;
        if (microbesInfo[key].is_correct) {
          return value.has_title;
        } else {
          return false;
        }
      });
      // console.log(Object.keys(Object.fromEntries(correctMicrobes)));
      return Object.keys(Object.fromEntries(correctMicrobes));
    },
    isCompletedTitle(state) {
      const microbesTitleKey = [];
      stagesInfo.forEach(_ => microbesTitleKey.push([]));
      Object.entries(state.microbesStore).forEach(item => {
        const [ key, value ] = item;
        if (value.has_title) {
          microbesTitleKey[microbesInfo[key].stage[0] - 1].push(key);
        }
      });

      microbesTitleKey.forEach(key => key.sort());

      const completedStages = stagesInfo.filter((value, idx) => {
        return microbesTitleKey[idx].toString() === [...value.target_microbes].sort().toString();
      });

      // console.log(Object.keys(completedStages).length > 3);
      return Object.keys(completedStages).length > 3;
    },
    titleAcquiredStages(state) {
      const correctMicrobesTitleKey = [];
      stagesInfo.forEach(_ => correctMicrobesTitleKey.push([]));
      Object.entries(state.microbesStore).forEach(item => {
        const [ key, value ] = item;
        if (microbesInfo[key].is_correct && value.has_title) {
          correctMicrobesTitleKey[microbesInfo[key].stage[0] - 1].push(key);
        }
      });
      correctMicrobesTitleKey.forEach(key => key.sort());

      // console.log(correctMicrobesTitleKey);

      return stagesInfo.filter((value , idx) => {
        // console.log(correctMicrobesTitleKey[idx].toString());
        // console.log([...value.correct_microbes].sort().toString());
        return correctMicrobesTitleKey[idx].toString() === [...value.correct_microbes].sort().toString();
      });
    },
    incorrectTitleAcquiredStages(state) {
      const incorrectMicrobesTitleKey = [];
      stagesInfo.forEach(_ => incorrectMicrobesTitleKey.push([]));
      Object.entries(state.microbesStore).forEach(item => {
        const [ key, value ] = item;
        if (!microbesInfo[key].is_correct && value.has_title) {
          incorrectMicrobesTitleKey[microbesInfo[key].stage[0] - 1].push(key);
        }
      });

      incorrectMicrobesTitleKey.forEach(key => key.sort());

      // console.log(incorrectMicrobesTitleKey);

      return stagesInfo.filter((value , idx) => {
        // console.log(incorrectMicrobesTitleKey[idx].toString());
        // console.log([...value.incorrect_microbes].sort().toString());
        return incorrectMicrobesTitleKey[idx].toString() === [...value.incorrect_microbes].sort().toString();
      });
    },
    stagesHasNew(state) {
      const newTitleMicrobes = Object.fromEntries(Object.entries(state.microbesStore).filter(item => {
        const [ _, value ] = item;
        return value.is_new_title;
      }));
      const microbesTitleKey = Object.keys(newTitleMicrobes);
      return stagesInfo.filter(value => {
        return value.correct_microbes.find(name => microbesTitleKey.includes(name));
      });
    },
    stagesHasNewIncorrectTitle(state) {
      const newTitleMicrobes = Object.fromEntries(Object.entries(state.microbesStore).filter(item => {
        const [ _, value ] = item;
        return value.is_new_title;
      }));
      const microbesTitleKey = Object.keys(newTitleMicrobes);
      return stagesInfo.filter(value => {
        return value.incorrect_microbes.find(name => microbesTitleKey.includes(name));
      });
    },
    hasNewTitle(state) {
      const newMicrobesAndTitle = Object.entries(state.microbesStore).find(item => {
        const [ _, value ] = item;
        return value.is_new || value.is_new_title;
      });
      return newMicrobesAndTitle ? true: false;
    },
  },
  mutations: {
    addCount (state, name) {
      Object.entries(state.microbesStore).forEach(item => {
        const [key, obj] = item;
        if (key === name) {
          obj.total_count++;
          if (obj.total_count === 1) {
            obj.is_new = true;
          }
          if (obj.total_count === microbesInfo[key].max_count) {
            obj.is_new_title = true;
            obj.has_title = true;
          }
        }
      });
    },
    resetNew(state) {
      Object.values(state.microbesStore).forEach(obj => {
        obj.is_new = false;
        obj.is_new_title = false;
      });
    },
    initialized(state) {
      if (localStorage.getItem(`microbesStore`)) {
        localStorage.removeItem(`microbesStore`);
      }
      if (localStorage.getItem(`microbesStore1`)) {
        localStorage.removeItem(`microbesStore1`);
      }
      if (!localStorage.getItem(`microbesStore${microbesStoreVersion}`)) {
        // console.log('initialized');
        if (microbesStore) {
          state.microbesStore = microbesStore;
          const { toJSON } = jsonSerializer();
          localStorage.setItem(`microbesStore${microbesStoreVersion}`, toJSON(state.microbesStore));
          // console.log('initialized');
        }
      } else {
        // console.log('load');
        const { fromJSON } = jsonSerializer();
        state.microbesStore = fromJSON(localStorage.getItem(`microbesStore${microbesStoreVersion}`));
      }
    },
    load(state) {
      const { fromJSON } = jsonSerializer();
      state.microbesStore = fromJSON(localStorage.getItem(`microbesStore${microbesStoreVersion}`));
    },
    save(state) {
      const { toJSON } = jsonSerializer();
      localStorage.setItem(`microbesStore${microbesStoreVersion}`, toJSON(state.microbesStore));
      // console.log('saved');
    },
    remove(state) {
      localStorage.removeItem(`microbesStore${microbesStoreVersion}`);
      state.microbesStore = microbesStore;
      const { toJSON } = jsonSerializer();
      localStorage.setItem(`microbesStore${microbesStoreVersion}`, toJSON(state.microbesStore));
      // console.log('removed');
    }
  },
  actions: {
  },
  modules: {
  }
})
